<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-skeleton-loader
          v-if="Articulo.length === 0"
          fade-transition
          height="500"
          width="250"
          type="card"
          tile
        ></v-skeleton-loader>

        <v-carousel
          v-else
          height="auto"
          hide-delimiters
          :show-arrows="false"
          reverse-transition="fade-transition"
          delimiter-icon="mdi-checkbox-blank"
          transition="fade-transition"
        >
          <v-carousel-item style="height: auto; min-height: 300px">
            <div class="img_art">
              <img
                contain
                v-show="updir"
                @click="showMultiple"
                style="cursor: pointer"
                :src="`${domoapi2_img}Articulo/${checkCodigo}/Galeria?archivo=${currentIndex}&i=${updateImg}&Cia=15
                `"
              />
              <img
                v-show="!updir"
                @click="showMultiple"
                :src="`${domoapi2_img}Articulo/${checkCodigo}/Principal?i=${updateImg}&Cia=15`"
              />
            </div>
          </v-carousel-item>
          <!--
            se incluye un enlace a un video en un canal de youtube 
            <iframe width="560" height="500" :src="youtubeSrc" frameborder="0" allow="accelerometer; autoplay;encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          -->
        </v-carousel>
      </v-col>
      <v-col cols="12">
        <v-sheet class="mx-auto mt-n7" max-width="265">
          <v-slide-group v-model="currentIndex" class="pa-1" show-arrows>
            <v-slide-item v-for="(item, i) in listimg" :key="i">
              <v-card
                class="ma-1"
                height="55"
                width="70"
                @click="showOverlay(item, i)"
              >
                <v-img
                  :src="`${domoapi2_img}Articulo/${checkCodigo}/Galeria?archivo=${item.archivo}&i=${updateImg}`"
                  class="img_art2 mx-auto black--text align-end"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
                <v-overlay
                  :absolute="absolute"
                  :value="item.overlay"
                  z-index="1"
                ></v-overlay>
              </v-card>
            </v-slide-item>
          </v-slide-group>
        </v-sheet>
      </v-col>
    </v-row>
    <vue-easy-lightbox
      escEnabled
      moveEnabled
      :visible="visible"
      :imgs="apiImg"
      :index="index"
      @hide="handleHide"
    ></vue-easy-lightbox>
  </v-container>
</template>

<script>
import "vue-inner-image-zoom/lib/vue-inner-image-zoom.css";
import InnerImageZoom from "vue-inner-image-zoom";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      imgs: "", // Img Url , string or Array of string
      visible: false,
      index: 0, // default: 0
      idimg: 0,
      currentIndex: "",
      listimg: [],
      imgOne: null,
      absolute: true,
      overlay: false,
      updir: false,
      updateImg: Math.floor(Math.random() * 100),
    };
  },
  components: {
    InnerImageZoom,
  },
  props: {
    codart: String, //codigo del articulo
  },
  watch: {
    Leerdir() {
      this.LeerApiImg();
    },
  },
  created() {
    this.LeerApiImg();
  },
  methods: {
    showMultiple() {
      this.imgs = [];
      this.index = this.idimg; // index of imgList
      this.show();
    },
    show() {
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
    async LeerApiImg() {
      let that = this;
      const URL = `${this.domoapi2_img}Datos`;
      await axios
        .post(URL, {
          tipo: "Articulo",
          codigo: this.ChrEsp(this.codart),
          categoria: "Galeria",
          archivo: "",
        })
        .then(function (response) {
          const { data } = response;
          that.listimg = data;
          that.currentIndex = data[0].archivo;
          if (that.currentIndex) {
            that.updir = true;
          }
        })
        .catch(function () {
           console.log("Error al Leer Directorio!!");
        })
        .finally(() => (that.loadingdir = false));
    },
    showOverlay(art, index) {
      this.listimg.map((a) => (a.overlay = false));
      this.listimg[index].overlay = true;
      this.currentIndex = this.listimg[index].archivo;
      this.idimg = index;
      this.updateImg = Math.floor(Math.random() * 100);
    },
    ChrEsp(chr) {
      const chrSplit = chr.split("");
      let newChr = "";

      chrSplit.forEach((x) => {
        if (x === "/") newChr += "-";
        else if (x === ".") newChr += "-";
        else newChr += x;
      });

      return newChr;
    },
  },
  computed: {
    ...mapState(["Articulo", "Leerdir", "imgDetalleArt", "domoapi2_img"]),
    apiImg() {
      let data = [];
      let url = `${this.domoapi2_img}Articulo/${this.checkCodigo}/Galeria?archivo=`;
      //tiene galeria
      if (this.updir) {
        if (this.listimg) {
          this.listimg.forEach(function (item, index) {
            data.push(url + item.archivo);
          });
        }
      } //no tiene galeria
      else if (!this.updir) {
        data.push(`${this.domoapi2_img}Articulo/${this.checkCodigo}/Principal`);
      }
      return data;
      //"`${updir ?  :  }`"
    },
    checkCodigo() {
      return this.ChrEsp(this.codart);
    },
  },
};
</script>

<style scoped>
.img_art {
  max-width: 55%;
  height: auto;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.img_art2 {
  max-width: 50%;
  height: auto;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
